/**
 * patientWording.js — R25 · PROD-139 (Dr. Rami 2026-10-03), patient P1. The one line a condition
 * card (and its Learn more modal) shows: patient wording, never the physician's.
 *
 * ★★ THE SHAPES THAT REACH ViewSummary's condition list:
 *   - the unified summary (orella-api generate_patient_education, v117+): { diagnosis, likelihood,
 *     icdCode, supportingFactors, patientDescription, whyRelevant, learnMore, condition,
 *     description } — `patientDescription` is the patient line; `description` is a copy of it.
 *   - the streamed DX section: { diagnosis, likelihood, icdCode, supportingFactors,
 *     patientDescription }.
 *   - the pre-visit summary's own differential (the physician's analysis) carries `diagnosis` and
 *     no patient line: anything else on it is not for the patient.
 *   - ★ the LEGACY patient summary (generate_patient_summary, conditionsToDiscuss): { condition,
 *     description, whyRelevant } — no `diagnosis`, no `patientDescription`. Its `description` IS
 *     patient wording ("Simple 1-2 sentence explanation", the legacy prompt), and review r1 S2
 *     restored it for exactly these items.
 * So: `patientDescription` when present; else `description` ONLY for a legacy item; else nothing.
 *
 * Pure (no imports). scripts/check-summary-patient-wording.mjs executes it.
 */
export const isLegacyCondition = (item) => !!item && typeof item === 'object'
  && typeof item.condition === 'string' && !('diagnosis' in item) && !('patientDescription' in item)

export function dxHook(item) {
  if (!item || typeof item !== 'object') return ''
  const p = typeof item.patientDescription === 'string' ? item.patientDescription.trim() : ''
  if (p) return p
  return isLegacyCondition(item) && typeof item.description === 'string' ? item.description.trim() : ''
}
